(function () {
  'use strict';

  angular
    .module('pixerf', [
      'ui.router',
      'ngRoute',
      'ngAnimate',
      'ui.bootstrap',
      'toastr',
      'angular-jwt',
      'ngResource',
      'loadingButton',
      'LocalStorageModule',
      'ngSanitize',
      'hm.readmore',
      'auth0.auth0',
      'infinite-scroll'
    ]);

})();

(function () {
     'use strict';
     angular
          .module('pixerf')
          .constant('messageConst', {
               "error": {
                    "SOME_THING_WRONG": "Oops! Looks like something went wrong. Please try again!"
               }
          });
})();
(function () {
    'use strict';

    angular
        .module('pixerf')
        .directive('underExposed', underExposed);

    function underExposed() {

        var directive = {
            scope: false,
            restrict: 'E',
            templateUrl: 'app/components/under-exposed/under-exposed.html',
            replace: true
        };
        return directive;
    }

})();

(function () {
    'use strict';

    angular
        .module('pixerf')
        .directive('defineSeries', defineSeries);

    function defineSeries() {

        var directive = {
            scope: false,
            restrict: 'E',
            templateUrl: 'app/components/define-series/define-series.html',
            replace: true
        };
        return directive;
    }

})();

(function () {
    'use strict';

    angular
        .module('pixerf')
        .directive('getInTouch', getInTouch);

    function getInTouch() {

        var directive = {
            scope: false,
            restrict: 'E',
            templateUrl: 'app/components/get-in-touch/get-in-touch.html',
            replace: true
        };
        return directive;
    }

})();

(function () {
    'use strict';

    angular
        .module('pixerf')
        .directive('about', about);

    function about() {

        var directive = {
            scope: false,
            restrict: 'E',
            templateUrl: 'app/components/about/about.html',
            controller: 'definePageCtrl as vm',
            replace: true
        };
        return directive;
    }

})();

(function () {
    'use strict';

    angular
        .module('pixerf')
        .factory('systemUtils', systemUtils);

    systemUtils.$inject = ['$timeout'];

    function systemUtils($timeout) {

        function apply(scope) {
            $timeout(function () {
                scope.$apply();
            })
        }

        function isMobile() {
            return window.innerWidth < 667;
        }

        function scrollTo(options) {
            var body = $("html, body");
            body.stop().animate({ scrollTop: 0 }, '500', 'swing');
        }

        return {
            apply: apply,
            isMobile: isMobile,
            scrollTo: scrollTo
        };
    }
})();
(function () {
    'use strict';
    angular
        .module('pixerf')
        .factory('socketSvc', socketSvc);

    socketSvc.$inject = ['pixerfUrl', '$log', 'systemUtils'];
    function socketSvc(pixerfUrl, $log, systemUtils) {
        var PIXERF_TOPICS = {
            IOA: {
                name: 'ioa',
                isSubscribed: false
            }
        };
        var mTopicSubscribeStatus = {

        }
        var mIsGeneralChannelSubscribed = false;
        var mSocket = null;
        var mGeneralChannel = null;
        var mPrivateChannel = null;
        function connect() {
            if (!mSocket) {
                mSocket = new Phoenix.Socket('wss://' + pixerfUrl.domainOnly + '/socket', {});
                mSocket.connect();
            }
            mSocket.onOpen(function () {
                $log.info("Socket Open");
            })
            mSocket.onError(function () {
                mSocket = null;
                $log.error("Socket error");
            })
            mSocket.onClose(function () {
                mSocket = null;
                $log.info("Socket close");
            })
        }
        function joinPublicChannel() {
            if (mSocket) return;
            connect();
            mGeneralChannel = mSocket.channel("room:general", {});
            mGeneralChannel.join();
            mGeneralChannel.on("joined", function () {
            })
            return mGeneralChannel;
        }
        function joinPrivateChannel(username, token) {
            if (mSocket) return;
            connect();
            mPrivateChannel = mSocket.channel("room:" + username, { guardian_token: token });
            mPrivateChannel.join();
        }
        function close() {
            mSocket.close();
        }
        function getPrivateChannel() {
            return mPrivateChannel;
        }
        function getPublicChannel() {
            return mGeneralChannel;
        }
        function subscribeTopic(topic, handler) {
            if (mGeneralChannel && mGeneralChannel.state === "joined" && !PIXERF_TOPICS[topic].isSubscribed) {
                PIXERF_TOPICS[topic].isSubscribed = true;
                mGeneralChannel.off(PIXERF_TOPICS[topic].name);
                mGeneralChannel.on(PIXERF_TOPICS[topic].name, function (msg) {
                    handler(msg);
                })
                mGeneralChannel.onClose(PIXERF_TOPICS.NOTIFICATIONS, function (msg) {
                    PIXERF_TOPICS[topic].isSubscribed = false;
                })
                mGeneralChannel.onError(PIXERF_TOPICS.NOTIFICATIONS, function (msg) {
                    PIXERF_TOPICS[topic].isSubscribed = false;
                })
            }
        }

        return {
            joinPrivateChannel: joinPrivateChannel,
            joinPublicChannel: joinPublicChannel,
            getPrivateChannel: getPrivateChannel,
            getPublicChannel: getPublicChannel,
            PIXERF_TOPICS: PIXERF_TOPICS,
            subscribeTopic: subscribeTopic
        };
    }
})();

(function () {
    'user strict';
    angular.module('pixerf').controller('definePageCtrl', definePageCtrl);
    definePageCtrl.$inject = [];
    function definePageCtrl() {

        var self = this;

        self.navigateTo = navigateTo;

        function navigateTo(section) {
            console.log(section);
        }
    }
})();
(function () {
	'use strict';
	angular.module('pixerf').config(routerConfig)
	routerConfig.$inject = ['$stateProvider']
	function routerConfig($stateProvider) {
		$stateProvider
			.state('define', {
				url: '/',
				templateUrl: 'app/define-page/define-page.html'
			})
			.state('define-section', {
				url: '/define',
				templateUrl: 'app/define-page/define-page.html'
			})
			.state('exposed', {
				url: '/under-exposed',
				templateUrl: 'app/define-page/define-page.html'
			})
			.state('get-in-touch', {
				url: '/get-in-touch',
				templateUrl: 'app/define-page/define-page.html'
			});
	}
})();
(function() {
    'use strict';
    angular
        .module('pixerf')
        .constant('authenticationConst', {
            AUTHENTICATION_STATE: {
                NOT_LOGIN: "NOT_LOGIN",
                TOKEN_EXPIRED: "TOKEN_EXPIRED",
                FAILED_RETREIVE_ACCOUNT_INTO: "FAILED_RETREIVE_ACCOUNT_INTO",
                FAILED_RE_AUTHENTICATE: "FAILED_RE_AUTHENTICATE",
                FAILED_SIGNUP: "FAILED_SIGNUP"
            },
            AUTH0_CONNECTION_TYPE:{
                FACEBOOK: "facebook",
                USERNAME_PASSWORD: "Username-Password-Authentication"
            }
        });
})();
function PixerfEnv(){
    this.ENV = {
        PRODUCTION : "PRODUCTION",
        STAGING: "STAGING",
        TESTING: "TESTING",
        DEVELOPING: "DEVELOPING"
    }


}
PixerfEnv.prototype = (function(){
    function getEnv(){
        var URL_PRFIX = "https://";
        if (!String.prototype.startsWith) {
            String.prototype.startsWith = function(searchString, position) {
                position = position || 0;
                return this.indexOf(searchString, position) === position;
            };
        }
        if(location.href.startsWith(URL_PRFIX + "gojek.pixerf.com")){
            return this.ENV.PRODUCTION;
        }
        else if (location.href.startsWith(URL_PRFIX + 'staging.pixerf.com')){
            return this.ENV.STAGING;
        }
        else if (location.href.startsWith(URL_PRFIX + 'qa.pixerf.com')){
            return this.ENV.TESTING;
        }
        return this.ENV.TESTING;
    }
    return {
        getEnv: getEnv
    }
})();
function PixerfAuth0Configurer(){
    this.ENV = {
        "PRODUCTION": {
            clientID: "CX71vZ6A5B2CRUWycgcwSjqRJomeQL1n",
            domain: "pixerf.au.auth0.com"
        },
        "STAGING": {
            clientID: "Qtn7RYBZ4tpP35pXDBj9PR0zYIEDPv4N",
            domain: "pixerf-staging.au.auth0.com"
        },
        "TESTING": {
            clientID: "d5Ehkv7aRKGthnC6l8AgHZmU2GaNK7K4",
            domain: "pixerf-qa.au.auth0.com"
        },
        "DEVELOPING": {
            clientID: "d5Ehkv7aRKGthnC6l8AgHZmU2GaNK7K4",
            domain: "pixerf-qa.au.auth0.com"
        }
    }
}
PixerfAuth0Configurer.prototype = (function(){
    function getEnv(){
        var pixerfEnv = new PixerfEnv();
        return this.ENV[pixerfEnv.getEnv()];
    }
    return {
        getEnv: getEnv
    }
})();
function PixerfAPIUrlConfigurer(){
    this.URL_PRFIX = "https://";
    this.URL_AFFIX = "/";
    this.ENV = {
        DEVELOPING: "phoenix.pixerf.com",
        PRODUCTION : "pixerf.com",
        STAGING: "staging.pixerf.com",
        TESTING: "qa.pixerf.com"
    }
}
PixerfAPIUrlConfigurer.prototype = (function(){
    function getBaseUrl(){
        var pixerfEnv = new PixerfEnv();
        return this.ENV[pixerfEnv.getEnv()];
    }
    return {
        getBaseUrl: getBaseUrl
    }
})();
(function () {
    'use strict';

    angular
        .module('pixerf')
        .directive('scrollTo', scrollTo);

    function scrollTo() {
        return {
            restrict: 'A',
            link: function (scope, $elm, attrs) {
                var idToScroll = attrs.href;
                $elm.on('click', function () {
                    var $target;
                    if (idToScroll) {
                        $target = $(idToScroll);
                    } else {
                        $target = $elm;
                    }
                    $("html, body").animate({ scrollTop: $target.offset().top }, "slow");
                    return false;
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('pixerf')
        .controller('indexCtrl', indexCtrl);

    indexCtrl.$inject = [];

    function indexCtrl() {
        var self = this;
    }
})();

(function () {
  'use strict';

  angular
    .module('pixerf')
    .run(runBlock);

  runBlock.$inject = ['$rootScope', 'socketSvc', 'systemUtils', '$route'];

  function runBlock($rootScope, socketSvc, systemUtils, $route) {
    $rootScope.message = {
      votable: true,
      published: {
        data: false
      },
      winners: {
        data: []
      }
    }
    // socketSvc.joinPublicChannel();
    setTimeout(function () {
      socketSvc.subscribeTopic(socketSvc.PIXERF_TOPICS.IOA.name.toUpperCase(), function (message) {
        $rootScope.message.published = message.published;
        $rootScope.message.votable = message.votable;
        systemUtils.apply($rootScope);
        $route.reload();
        location.reload();
      })
    }, 3000);
  }
})();

(function() {
  'use strict';

  angular
    .module('pixerf')
    .config(routerConfig);

  routerConfig.$inject = ['$stateProvider', '$urlRouterProvider'];

  function routerConfig($stateProvider, $urlRouterProvider) {
    'ngInject';
    $urlRouterProvider.when('', '/');
  }

})();

// /* global malarkey:false, moment:false */
// (function() {
//   'use strict';

//   angular
//     .module('pixerf')
//     .constant('moment', moment);

// })();

(function () {
	'use strict';
	angular
		.module('pixerf')
		.config(config)
		.provider('pixerfUrl', function () {

			var pixerfAPIUrlConfigurer = new PixerfAPIUrlConfigurer();
			var baseUrl = pixerfAPIUrlConfigurer.getBaseUrl();

			this.$get = function () {
				return {
					full: pixerfAPIUrlConfigurer.URL_PRFIX + baseUrl + pixerfAPIUrlConfigurer.URL_AFFIX,
					domainOnly: baseUrl
				}
			}

		});
	config.$inject = ['toastrConfig', '$httpProvider', 'angularAuth0Provider', 'jwtInterceptorProvider', 'jwtOptionsProvider'];
	function config(toastrConfig, $httpProvider, angularAuth0Provider, jwtInterceptorProvider, jwtOptionsProvider) {
		$httpProvider.defaults.withCredentials = true;
		toastrConfig.maxOpened = 1;
		toastrConfig.autoDismiss = true;
		toastrConfig.allowHtml = true;
		toastrConfig.extendedTimeOut = 15000;
		toastrConfig.closeButton = true;
		toastrConfig.positionClass = 'toast-top-center';
		toastrConfig.toastClass = 'pixerf-alert-message';

		jwtOptionsProvider.config({ whiteListedDomains: ["qa.pixerf.com", "pixerf.com"] });

		jwtInterceptorProvider.tokenGetter = ['localStorageService', function (localStorageService) {
			var token = localStorageService.get('PIXERF.TOKEN');
			return token;
		}];

		$httpProvider.interceptors.push('jwtInterceptor');

		var pixerfAuth0Evn = new PixerfAuth0Configurer().getEnv();
		angularAuth0Provider.init({
			domain: pixerfAuth0Evn.domain,
			clientID: pixerfAuth0Evn.clientID,
			responseType: 'token id_token',
			redirectUri: window.location.href
		});

	}

})();

angular.module("pixerf").run(["$templateCache", function($templateCache) {$templateCache.put("app/define-page/define-page.html","<div class=define><about></about><define-series></define-series><under-exposed></under-exposed><get-in-touch></get-in-touch></div>");
$templateCache.put("app/components/about/about.html","<section class=about id=about><div class=about__container><div class=about__logo><img class=desktop-show src=../assets/images/pixerf-logo.png alt=PIXERF> <img class=mobile-show src=../assets/images/pixerf-logo-horizontal.png alt=PIXERF></div><div class=about__navigation><div class=about__navigation__item><a scroll-to href=#about>ABOUT</a></div><div class=about__navigation__item><a scroll-to href=#define>DEFINER SERIES</a></div><div class=about__navigation__item><a scroll-to href=#under-exposed>UNDER/EXPOSED</a></div><div class=about__navigation__item><a scroll-to href=#get-in-touch>GET IN TOUCH</a></div></div><div class=about__branding><div class=\"about__branding__text first-line\">Definers <span>+</span></div><div class=\"about__branding__text second-line\"><span>+</span> Under/Exposed</div></div><div class=about__branding__description>PIXERF is looking for Asia\'s most inspiring and extraordinary creators so that we can document, share and amplify their stories to the world.</div><div class=about__support><div class=about__support__scroll-down><a scroll-to href=#define></a></div><div class=about__support__author><div class=about__support__author__text>Photo by</div><div class=about__support__author__name><a href=https://pixerf.com/#/user-home-page/60314 target=_blank>Tom Potisit</a></div></div></div></div></section>");
$templateCache.put("app/components/define-series/define-series.html","<section class=define-series id=define><div class=define-series__container><div class=define-series__container__col-left><div class=define-series__logo><img src=../assets/images/define.png alt=define></div><div class=define-series__container__col-left__content>The <i>Definer Series</i> is a web series that traces the stories of influential creators from their perspective, and how they have realised their true calling through the process of creation.</div></div><div class=define-series__container__col-right><div class=define-series__container__col-right__content><div class=define-series__container__col-right__content__author>Tom Potisit</div><div class=define-series__container__col-right__content__brief>A Thai-born renowned fashion and commercial photographer who stimulates conversations on relevant social and environmental issues through fashion and artistic photography. His work has been featured at Art Basel in Miami, USA, Saatchi Art Gallery, London and TedX, Bangkok.</div></div></div></div></section>");
$templateCache.put("app/components/get-in-touch/get-in-touch.html","<section class=get-in-touch id=get-in-touch><div class=\"get-in-touch__container clearfix\"><div class=get-in-touch__container__col-left><div class=get-in-touch__container__header>Are you a Definer?</div><div class=\"get-in-touch__container__content mobile-show first-content\"><div>Know an amazing visual creator who\'s been shaking up the creative scene? Nominate someone you know (or yourself) to be featured. Visit our nomination page below, fill in the details and successful applicants will be notified.</div></div><div class=\"get-in-touch__container__content desktop-show\"><div>Know an amazing visual creator who\'s been shaking up the creative scene?</div><div>Nominate someone you know (or yourself) to be featured. Visit our nomination page below, fill in the details and successful applicants will be notified.</div></div><a href=https://docs.google.com/forms/d/e/1FAIpQLSctJB-GefwgGqNhedlnE7dZD8gLeJvhVMmGvNJBlELNir5fHg/viewform target=_blank class=get-in-touch__container__btn>NOMINATE YOUR DEFINER</a></div><div class=get-in-touch__container__col-right><div class=get-in-touch__container__header>Are you Under/Exposed?</div><div class=\"get-in-touch__container__content mobile-show second-content\"><div>Maybe you know someone who deserves the spotlight. Maybe you know someone who fits the bill. Visit our nomination page below, fill in the details and you (or your nominee) could be our pick.</div></div><div class=\"get-in-touch__container__content desktop-show\"><div>Maybe you know someone who deserves the spotlight.</div><div>Maybe you know someone who fits the bill. Visit our nomination page below, fill in the details and you (or your nominee) could be our pick.</div></div><a href=https://docs.google.com/forms/d/e/1FAIpQLSdYOdDCL5h4e5S2GTAXS7MQPq_BtHv_H8KcUAPFR1_WKEzNFw/viewform target=_blank class=get-in-touch__container__btn>GET DISCOVERED</a></div></div></section>");
$templateCache.put("app/components/under-exposed/under-exposed.html","<section class=under-exposed id=under-exposed><div class=under-exposed__container><div class=under-exposed__logo><img src=../assets/images/exposed-logo.png alt=exposed></div><div class=under-exposed__container__content><div>It\'s not about your follower count.</div><div>The only thing that matters is your talent. The Under/Exposed talent search aims to put the spotlight on underexposed creators and give them a stage to shine!</div></div></div></section>");}]);